import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'reportLegend',
    templateUrl: './report-legend.component.html',
    styleUrls: ['./report-legend.component.css']

    // entryComponents: [
    //     ReportParametersComponent
    //     ]
})

export class ReportLegendComponent implements OnInit, OnDestroy {

    thisDialogRef: MatDialogRef<ReportLegendComponent>;
    backgroundColorForDistrictDefinedDefinition: string;
    backgroundColorForUserDefinedDefinition: string;

    legendItem_1 = 'Personal Report Options'; // default
    legendItem_2 = 'District Report Options'; // default


    constructor(
        reportLegendDialogRef: MatDialogRef<ReportLegendComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private reportService: ReportingService,
        // private myReportsComponent: MyReportsComponent,
        // private loginService: LoginService,
        private dialog: MatDialog,



    ) {
        this.thisDialogRef = reportLegendDialogRef;
        // get definition colors from reportService
        this.backgroundColorForUserDefinedDefinition = this.reportService.backgroundColorForUserDefinedDefinition;
        this.backgroundColorForDistrictDefinedDefinition = this.reportService.backgroundColorForDistrictDefinedDefinition;


        if (this.data != null && this.data != undefined) {
            this.legendItem_1 = data.legendItem_1;
            this.legendItem_2 = data.legendItem_2;
        }

    } // end constructor


    ngOnInit() {

        // place holder
    }

    ngOnDestroy() {

        this.reportService.isForSchedule = false;
    }


    closeClick() {

        this.thisDialogRef.close();
    }










}// end class